import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import ObjectiveGapGrid from './ObjectiveGapGrid';

type Props = {
  rows?: any[];
  loading?: boolean;
};

class BieWhatIfObjectiveGapPanel extends React.PureComponent<Props> {
  render() {
    return (
      <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
        <Stack spacing={1.5}>
          <div>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              What-if Objective Targets
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Arbitrary targets used to interpret the current simulation outcome.
            </Typography>
          </div>

          <ObjectiveGapGrid
            rows={this.props.rows || []}
            loading={this.props.loading}
          />
        </Stack>
      </Paper>
    );
  }
}

export default BieWhatIfObjectiveGapPanel;
